import { Page } from "@/models/page-models/Page";

export const ProductionReport: Page = {
  "path": "production-report",
  "name": "Production Report",
  "props": {
    "data": {
      "title": "Production Report",
      "printable": "FALSE",
      "url": "production-report",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.factoryTicket",
                  "label": "{{translated('select_factory_ticket')}}",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetFormData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.process"
                      },
                      "name": "resetFormData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "resetProcessName",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.machine"
                      },
                      "name": "resetProcessName"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyOrderId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.order._id",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.order"
                      },
                      "name": "copyOrderId"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.order",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    },
                    {
                      "executionOrder": 3,
                      "pageFunction": {
                        "name": "getOrderProcesses",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/factoryticket/orderprocess?id={{formData.order}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orderProcesses",
                        "arg3Key": "addToState",
                        "arg3Value": "{\"actionName\":\"addMultipleGoods\",\"variable\":\"fetchedData.orderProcesses.data.goods\"}"
                      },
                      "name": "getOrderProcesses"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "convertProcesses",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "fetchedData.orderProcesses.data",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getConvertedProcesses",
                        "arg3Key": "destinationKey",
                        "arg3Value": "fetchedData",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object",
                        "arg5Key": "append",
                        "arg5Value": "TRUE"
                      },
                      "name": "convertProcesses"
                    },
                    {
                      "executionOrder": 4,
                      "pageFunction": {
                        "name": "getProductData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/detail",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.selectedProduct",
                        "arg3Key": "sourceTransformationFn",
                        "arg3Value": "transformProductData",
                        "arg4Key": "postData",
                        "arg4Value": "fetchedData.productForm"
                      },
                      "name": "getProductData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getFactoryTicketData",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/factoryticket/get?id={{formData.factoryTicket}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.selectedFactoryTicket",
                        "arg3Key": "sourceTransformationFn",
                        "arg3Value": "transformFactoryTicketData"
                      },
                      "name": "getFactoryTicketData"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.factoryTickets.data",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,factoryTicketDescription,{{__item}})",
                  "validationKey": "order"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.machine",
                  "label": "{{translated('select_process')}}",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedProcess",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.process"
                      },
                      "name": "copySelectedProcess"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyDefaultFormValues",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultFormValues",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultFormValues"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyMachineName",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "formData.process.machineDetail._id",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.productionMachine"
                      },
                      "name": "copyMachineName"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "items": "fetchedData.processes",
                  "itemText": "machine",
                  "itemValue": "_key",
                  "formula": "fn(HELPER_FN,productionProcess,{{__item}})",
                  "validationKey": "process"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "fetchedData.selectedOrder",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrder}}"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "{{translated('production_entry_details')}}",
                  "showIf": "{{formData.order}}"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.productionMachine",
                  "label": "{{translated('search_machine')}}",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedMachineData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData.machine"
                      },
                      "name": "copySelectedMachineData"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyDefaultMachineSpeeds",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultMachineSpeeds",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultMachineSpeeds"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "items": "fetchedData.machines.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "validationKey": "machine"
                },
                {
                  "type": "input",
                  "variable": "formData.numberOfMen",
                  "label": "{{translated('number_of_men')}}",
                  "unit": "men",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "numberOfMen"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.standardSpeed",
                  "label": "{{translated('standard_speed')}}",
                  "unit": "m/min",
                  "disabled": "TRUE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "standardSpeed"
                },
                {
                  "type": "input",
                  "variable": "formData.activeSpeed",
                  "label": "{{translated('active_speed')}}",
                  "unit": "m/min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "activeSpeed"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.setupDT",
                  "label": "{{translated('setup_dt')}}",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "setupDT"
                },
                {
                  "type": "input",
                  "variable": "formData.maintenanceDT",
                  "label": "{{translated('maintenance_dt')}}",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "maintenanceDT"
                },
                {
                  "type": "input",
                  "variable": "formData.productionDT",
                  "label": "{{translated('production_dt')}}",
                  "unit": "min",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "productionDT"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.hourMeterStart",
                  "label": "{{translated('hour_meter_start')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "hourMeterStart"
                },
                {
                  "type": "input",
                  "variable": "formData.hourMeterEnd",
                  "label": "{{translated('hour_meter_end')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "hourMeterEnd"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.setupWaste",
                  "label": "{{translated('setup_waste')}}",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "setupWaste"
                },
                {
                  "type": "input",
                  "variable": "formData.maintenanceWaste",
                  "label": "{{translated('maintenance_waste')}}",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "maintenanceWaste"
                }
              ]
            },
            {
              "name": "10",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.trimWaste",
                  "label": "{{translated('trim_waste')}}",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "trimWaste"
                },
                {
                  "type": "input",
                  "variable": "formData.productionWaste",
                  "label": "{{translated('production_waste')}}",
                  "unit": "kg",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "productionWaste"
                }
              ]
            },
            {
              "name": "11",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.productionDate",
                  "label": "{{translated('production_date')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}",
                  "validationKey": "productionDate"
                },
                {
                  "type": "timePicker",
                  "variable": "formData.timeFrom",
                  "label": "{{translated('time_from')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}"
                },
                {
                  "type": "timePicker",
                  "variable": "formData.timeTo",
                  "label": "{{translated('time_to')}}",
                  "disabled": "FALSE",
                  "showIf": "{{formData.order}}"
                },
                {
                  "type": "label",
                  "variable": "formData.timeSpent",
                  "label": "{{translated('total_hours')}}",
                  "showIf": "{{formData.order}}",
                  "labelType": "formula",
                  "formula": "fn(TIME_DIFF,{{formData.timeFrom}},{{formData.timeTo}})",
                  "storeFormulaValue": true
                }
              ]
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "custom_ProductionReport",
                  "variable": "formData.process",
                  "label": "Production Report",
                  "disabled": "FALSE",
                  "showIf": "{{formData.process}}",
                  "config": {
                    "goodsVariable": "fetchedData.orderProcesses.data.goods",
                    "processesVariable": "fetchedData.orderProcesses.data.processes",
                    "resetData": true,
                    "wipVariable": "fetchedData.factoryWip.data",
                    "orderVariable": "fetchedData.selectedOrder"
                  }
                }
              ]
            },
            {
              "name": "13",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Save",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "saveProductionReport",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/productionreport",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "refreshPage",
                        "arg3Value": "TRUE"
                      },
                      "name": "saveProductionReport"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{formData.process}}",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getFactoryTickets",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/factory-ticket/to-produce",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.factoryTickets"
        },
        "name": "getFactoryTickets"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMachines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/machines/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.machines"
        },
        "name": "getMachines"
      }
    ],
    "functions": [
      {
        "name": "getConvertedProcesses",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "processes": "fn(TO_ARRAY,{{__selectedObject.processes}})"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultFormValues",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "productionDate": "fn(HELPER_FN,dateFormat,{{TODAYS_DATE}},date-picker)",
          "setupDT": "0",
          "maintenanceDT": "0",
          "productionDT": "0",
          "setupWaste": "0",
          "maintenanceWaste": "0",
          "trimWaste": "0",
          "productionWaste": "0"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultMachineSpeeds",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "standardSpeed": "{{formData.machine.mechanicalSpeed}}",
          "activeSpeed": "{{formData.machine.mechanicalSpeed}}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_OPERATOR",
  "visible": true
}